import { render } from "./BiochemicalGeneticsReport.vue?vue&type=template&id=08751014"
import script from "./BiochemicalGeneticsReport.vue?vue&type=script&lang=js"
export * from "./BiochemicalGeneticsReport.vue?vue&type=script&lang=js"

import "./BiochemicalGeneticsReport.vue?vue&type=style&index=0&id=08751014&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__